<template>
  <div class="menu-wrap" :class="isOpenMenu ? 'openMenu' : ''">
    <header class="cd-main-header">
      <a class="cd-logo" href="/">
        <span class="cd-logo__icon">
        </span>
        <span class="cd-logo__main">
          <span class="cd-logo__logo">
            <svg xmlns:xlink="http://www.w3.org/1999/xlink" width="110" height="22">
              <defs>
                  <path id="a" d="M16.58 20.12V.16H.47v19.96h16.11z"></path>
                  <path id="c" d="M16.12 21.44H0V.15h16.12z"></path>
                  <path id="e" d="M0 .16v20.3h23.31V.16z"></path>
              </defs>
              <g fill="none" fill-rule="evenodd">
                  <g transform="translate(92.51 .98)">
                      <mask id="b" fill="#fff">
                          <use xlink:href="#a"></use>
                      </mask>
                      <path fill="#926a36" class="logo-hover" d="M.85 20.12a.37.37 0 0 1-.38-.38c0-.18.13-.37.38-.37h.76V.9H.86A.37.37 0 0 1 .49.53C.5.35.62.16.87.16h1.91c.15.01.27.08.37.2L14.36 16.9V.9h-.72a.37.37 0 0 1-.37-.37c0-.18.13-.37.37-.37h2.57c.24 0 .37.19.37.37s-.13.38-.37.38h-.74v18.3a.7.7 0 0 1-.7.7.7.7 0 0 1-.58-.33l-.09-.12L2.71 2.9v16.46h.75c.24 0 .37.2.37.37 0 .18-.13.38-.37.38H.85z" mask="url(#b)"></path>
                  </g>
                  <g transform="translate(50.2 .41)">
                      <mask id="d" fill="#fff">
                          <use xlink:href="#c"></use>
                      </mask>
                      <path fill="#926a36" class="logo-hover" d="M8.44 21.44c-.59 0-1.18-.05-1.75-.15-3.21-.45-4.83-1.85-5.52-2.6l-.48.69c-.09.13-.34.22-.57.06-.2-.13-.1-.5.01-.62l1.58-2.22a.5.5 0 0 1 .29-.14c.15 0 .3.1.35.25.06.14 0 .28-.1.42l-.52.76a8.37 8.37 0 0 0 3.49 2.08 8.54 8.54 0 0 0 2.89.47 9.5 9.5 0 0 0 3.35-.6 5.97 5.97 0 0 0 1.36-.85c.67-.54 1.78-1.67 1.72-3.16-.05-1.3-.95-2.55-2.67-3.74-.33-.23-.93-.56-1.69-.99l-.25-.13c-2.38-1.32-5.95-3.3-7-4.94a4.04 4.04 0 0 1-.54-2.97A3.5 3.5 0 0 1 4.22.88c.87-.48 2-.73 3.37-.73.38 0 .72.02.97.03.66.05 1.8.26 2.3.39a9.38 9.38 0 0 1 3.77 1.9l.55-.77a.5.5 0 0 1 .3-.14c.15 0 .3.1.36.24.05.14.02.29-.1.4l-1.52 2.13a.37.37 0 0 1-.26.11.4.4 0 0 1-.36-.24c-.05-.14-.02-.27.09-.4l.42-.57a9.74 9.74 0 0 0-1.21-.83 9.96 9.96 0 0 0-4.87-1.14c-1.4 0-2.33.24-3.18.8-1.23.84-.83 2.22-.45 2.84.64 1.02 2.54 2.08 4.55 3.2.63.37 1.43.81 2.18 1.27.82.5 1.5.94 2.07 1.38 1.49 1.12 2.38 2.2 2.72 3.3 0 .03.88 2.57-1.09 4.71a8.51 8.51 0 0 1-6.4 2.68" mask="url(#d)"></path>
                  </g>
                  <path fill="#926a36" class="logo-hover" d="M76.06 21.1a.37.37 0 0 1-.38-.38c0-.18.13-.37.38-.37h.75v-7h-7.28v7h.74c.24 0 .37.19.37.37s-.13.37-.37.37H67.1a.37.37 0 0 1-.37-.37c0-.18.13-.37.37-.37h.74V6.07h-.75a.36.36 0 0 1-.38-.38c0-.18.13-.37.38-.37h3.17c.24 0 .37.2.37.37 0 .18-.13.38-.37.38h-.74v6.34h7.28V6.07h-.75a.37.37 0 0 1-.37-.38c0-.18.13-.37.37-.37h3.16c.24 0 .37.2.37.37 0 .18-.13.38-.37.38h-.74v14.28h.75c.24 0 .37.19.37.37s-.13.37-.37.37h-3.17zm4.76 0a.36.36 0 0 1-.37-.38c0-.18.13-.37.37-.37h.74l-.04-14.28h-.76a.37.37 0 0 1-.38-.38c0-.18.14-.37.38-.37h10.58c.22 0 .37.14.4.33l.44 2c0 .11-.02.22-.1.3a.39.39 0 0 1-.28.12c-.2 0-.32-.15-.37-.34l-.39-1.43H83.2v6.1h6.95v-.74c0-.25.2-.38.37-.38.19 0 .38.13.38.38v2.38c0 .25-.2.38-.38.38a.37.37 0 0 1-.37-.38v-.69H83.2v6.77h8.16l.61-1.34a.36.36 0 0 1 .34-.23.4.4 0 0 1 .33.18c.06.1.07.22.02.34l-.8 1.79a.37.37 0 0 1-.34.24h-10.7z"></path>
                  <path fill="#926a36" d="M41.44 5.99c-1.22.15-1.86.77-2.55 1.79a8.81 8.81 0 0 0-1 5.8c.53 3.72 2.92 6.53 5.56 6.53.15 0 .32-.01.5-.04.75-.1 1.44-.57 2.06-1.4.47-.62.72-1.23.75-1.3.52-1.33.66-2.98.4-4.77C46.62 8.83 44.22 6 41.6 6h-.15zm1.25 15.45c-3 0-5.73-3.13-6.33-7.28-.37-2.61.2-5.24 1.56-7.03.27-.36 1.77-2.17 4-2.27.14-.02.3-.03.45-.03 1.88 0 3.68 1.2 4.92 3.24V6.11h-.01a.37.37 0 0 1-.38-.37c0-.19.13-.38.38-.38h2.44c.24 0 .37.2.37.38s-.13.37-.37.37h-.75v14.24h.76c.24 0 .37.19.37.37s-.13.37-.37.37h-2.5a.37.37 0 0 1-.37-.37c0-.18.13-.37.38-.37h.05v-1.71a7 7 0 0 1-1.71 1.79c-.68.49-1.55.86-2.27.97-.22.02-.42.04-.62.04z"></path>
                  <g transform="translate(0 .98)">
                      <mask id="f" fill="#fff">
                          <use xlink:href="#e"></use>
                      </mask>
                      <path fill="#926a36" d="M15.95 5.01c-1.22.15-1.86.77-2.55 1.8a8.84 8.84 0 0 0-1.01 5.8c.54 3.72 2.93 6.53 5.55 6.53a3.64 3.64 0 0 0 .85-.12l.1-.02c.5-.17.93-.46 1.4-.94 1.21-1.56 1.73-3.97 1.38-6.43C21.12 7.85 18.73 5 16.1 5h-.15zm1.25 15.45c-.98 0-1.97-.34-2.87-.98-.21.32-.58.61-1 .63H.38a.37.37 0 0 1-.38-.37c0-.18.13-.37.38-.37h.74V.9H.36A.37.37 0 0 1 0 .53C0 .35.13.16.37.16h3.45c.24 0 .37.19.37.37s-.13.38-.37.38h-.76v18.24H13.2a.6.6 0 0 0 .46-.23l-.05-.04a9.93 9.93 0 0 1-2.73-5.7c-.45-3.06.37-6 2.13-7.66a5.99 5.99 0 0 1 3.88-1.66c3 0 5.72 3.09 6.31 7.18.44 3.01-.38 5.9-2.12 7.56-.23.26-.53.52-.86.76-.68.53-1.63.94-2.4 1.06-.21.03-.42.04-.6.04z" mask="url(#f)"></path>
                  </g>
                  <path fill="#926a36" d="M26.51 12.4l2.54.02c1.55 0 1.8-.03 1.84-.04a3.02 3.02 0 0 0 2.46-3.02 2.78 2.78 0 0 0-1.39-2.27 8 8 0 0 0-1.01-.4c-1.05-.31-3-.36-4.07-.36h-.37v6.07zm8.27 8.68c-.34-.47-3.57-5.38-4.01-6.05-.49-.74-.94-1.64-1.56-1.65a9.5 9.5 0 0 0-.99-.03h-1.71v7h.74c.24 0 .37.19.37.37s-.13.37-.37.37H24.1a.37.37 0 0 1-.37-.37c0-.18.13-.37.37-.37h.73V6.1h-.73a.37.37 0 0 1-.37-.37c0-.19.13-.38.37-.38h2.97c1.53 0 2.6.01 3.16.05 1.25.08 2.18.47 2.52.63a4 4 0 0 1 2.28 3.3c.05.93-.31 1.91-1 2.68a3.96 3.96 0 0 1-2.42 1.3c.06.08 4.15 6.36 4.67 7.03h.77c.25 0 .38.19.38.37s-.13.37-.38.37h-2.27z"></path>
              </g>
            </svg>
          </span>
        </span>
      </a>
      <nav class="cd-nav">
        <ul class="cd-primary-nav is-fixed">
          <li><a class="top-nav__unit top-nav__menu" href="/shopbuketyi/">{{ $t('Bouquets') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/about/">{{ $t('AboutUs') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/oplata/">{{ $t('Payment') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/dostavka/">{{ $t('Delivery') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/shops/">{{ $t('Shop') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/contact/">{{ $t('Contacts') }}</a></li>
          <li><div class="top-nav__unit top-nav__menu space"></div></li>
          <li v-if="!isLoggedIn">
            <router-link class="top-nav__link" :to="{name: 'orders'}">
              <div class="top-nav__unit"><img class="top-nav__unit__user" :src="logoUser" alt="logo user"></div>
            </router-link>
          </li>
          <li v-if="isLoggedIn">
            <div class="top-nav__link" @click="logout">
              <div class="top-nav__unit">{{ $t('Logout') }}</div>
            </div>
          </li>
          <li>
            <dashboard-topbar-cart/>
          </li>
          <li>
            <div class="hamburger" @click="openCloseMenu()" :class="isOpenMenu ? 'openMenu' : ''">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </li>
          <li><div class="top-nav__unit space-small top-nav__menu"></div></li>
        </ul>
      </nav>
      <nav class="cd-mobile-nav" :class="isOpenMenu ? 'openMenu' : ''">
        <ul class="cd-primary-nav is-fixed">
          <li><a class="top-nav__unit" href="/bouquets/">{{ $t('Bouquets') }}</a></li>
          <li><a class="top-nav__unit" href="/about-company-1/">{{ $t('AboutUs') }}</a></li>
          <li><a class="top-nav__unit" href="/payment/">{{ $t('Payment') }}</a></li>
          <li><a class="top-nav__unit" href="/delivery/">{{ $t('Delivery') }}</a></li>
          <li><a class="top-nav__unit" href="/shops/">{{ $t('Shop') }}</a></li>
          <li><a class="top-nav__unit" href="/contacts/">{{ $t('Contacts') }}</a></li>
        </ul>
      </nav>
    </header>
  </div>
</template>

 <script>
 import {mapGetters} from "vuex";
 import {getterTypes, actionTypes} from "@/store/modules/auth";
 import DashboardTopbarCart from "@/components/Cart.vue"

 export default {
   name: 'DashboardTopbar',
   components: {
     DashboardTopbarCart,
   },
   data(){
     return {
       logoUser: require('@/assets/svg/person-circle.svg'),
       logoCart: require('@/assets/svg/cart3.svg'),
       isOpenMenu: false,
     }
   },
    computed: {
      ...mapGetters({
        isLoading: getterTypes.isLoading,
        isLoggedIn: getterTypes.isLoggedIn,
        currentUser: getterTypes.currentUser,
      }),
    },
   methods: {
     logout(){
       this.$store.dispatch(actionTypes.logout)
     },
     openCloseMenu(){
       if (this.isOpenMenu === false){
         this.isOpenMenu = true
       } else {
         this.isOpenMenu = false
       }
     }
   }
 }
 </script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .cls-1{
    fill:#384967;
  }
  .menu-wrap.openMenu{
    height: 410px !important;
    @media only screen and (min-width: $max-width-tablet) {
      height: 76px !important;
    }
  }
  .menu-wrap{
    top: 0;
    width: 100%;
    height: 76px;
    position: fixed;
    left: 0;
    z-index: 9999;
    background-color: $bg-topbar;
    opacity: 95%;
    box-shadow: 0 3px 3px 0 rgba(0,0,0,.1);
    transition: top .05s;
    .cd-main-header{
      display: block;
      max-width: 1360px;
      margin: 0 auto;
      height: 76px;
      .cd-logo{
        top: 22px;
        left: 15px;
        display: inline-flex;
        justify-content: flex-start;
        position: relative;
        &__main {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          //@media only screen and (max-width: $max-width-laptop) {
          //  display: none;
          //}
        }
        &__logo{
          color: $fd;
          width: 201px;
          display: inline-block;
        }
        &__logo:hover .logo-hover{
          fill: #da4453;
        }
        &__slogan{
          color: $fd;
          width: 166px;
          display: inline-block;
        }
        .cd-logo__icon{
          flex-direction: column;
          align-items: center;
          color: $fd;
          width: 30px;
          display: none;
          //@media only screen and (max-width: $max-width-laptop) {
          //  display: inline-block;
          //  padding-top: 10px;
          //}
        }
      }
      .cd-mobile-nav.openMenu{
        display: inline;
      }
      .cd-nav{
        top: 0;
        float: right;
        .hamburger{
          display: none;
          cursor: pointer;
          padding-top: 22px;
          @media only screen and (max-width: $max-width-tablet) {
            display: block;
          }
          .line{
            width: 30px;
            height: 3px;
            background: $fd;
            margin: 6px 0;
          }
        }
      }
      .cd-primary-nav{
        display: inline;
        padding: 0 25% 0 0;
         @media only screen and (max-width: $max-width-tablet) {
           display: flex;
         }
      }
      .cd-primary-nav>li {
        margin-left: 15px;
        float: left;
        list-style: none;
        @media only screen and (max-width: $max-width-tablet) {
          margin-left: 0;
        }
      }
      .cd-primary-nav>li>a, .cd-primary-nav>li>div {
        font-size: 16px;
        line-height: 80px;
        height: 80px;
        text-transform: uppercase;
        text-decoration: none;
        position: relative;
        display: inline-block;
        padding: 0 10px;
        color: #2e3233;
        overflow: visible;
        border-bottom: none;
        -webkit-transition: color .3s,box-shadow .3s;
        -moz-transition: color .3s,box-shadow .3s;
        transition: color .3s,box-shadow .3s;
      }
      .cd-primary-nav>li>.space{
        width: 100px;
      }
      .cd-primary-nav>li>.space-small{
        width: 20px;
      }
      .top-nav{
        &__link{
          cursor: pointer;
        }
        &__unit{
          &__user{
            height: 22px;
            width: 22px;
            opacity: 80%;
          }
          &__cart{
            height: 22px;
            width: 22px;
            opacity: 80%;
          }
        }
        &__menu{
          @media only screen and (max-width: $max-width-tablet) {
            display: none !important;
          }
        }
      }
      .cd-mobile-nav{
        display: none;
        padding: 0 0 0 35%;
        position: absolute;
        top: 80px;
        @media only screen and (max-width: 420px) {
          padding: 0 0 0 25%;
        }
        @media only screen and (max-width: 364px) {
          padding: 0 0 0 30%;
        }
        @media only screen and (min-width: $max-width-tablet) {
            display: none !important;
        }
        .cd-primary-nav{
          display: inline-grid;
        }
        .cd-primary-nav>li>a, .cd-primary-nav>li>div {
          line-height: 50px;
          height: 50px;
        }
      }
      .cd-mobile-nav ul{
        display: block;
        width: fit-content;
        margin: 0 auto 0 auto;
      }
      .cd-mobile-nav>li {
        margin-left: 15px;
        list-style: none;
      }
    }
  }
</style>